// extracted by mini-css-extract-plugin
export default {"custom-wrapping":"styles_custom-wrapping__u-yG2"};